<template>
  <v-app id="inspire">
    <!-- 移动端访问限制页面 -->
    <div v-if="isMobileDevice() || isMobileScreen()" class="mobile-block-page">
      <v-container class="fill-height">
        <v-row justify="center" align="center">
          <v-col cols="12" sm="8" md="6" lg="4">
            <v-card class="text-center pa-6">
              <v-icon
                icon="mdi-cellphone-off"
                size="x-large"
                color="error"
                class="mb-4"
              ></v-icon>
              <v-card-title class="text-h5 mb-4">
                暂未开放移动端访问
              </v-card-title>
              <v-card-text>
                <p class="text-body-1 mb-2">为了系统安全和使用体验，本系统仅支持电脑端访问。</p>
                <p class="text-caption text-grey">请使用电脑浏览器访问本系统</p>
              </v-card-text>
              <v-card-actions class="justify-center">
                <v-btn
                  color="primary"
                  @click="refreshPage"
                  variant="outlined"
                >
                  刷新页面
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- 电脑端正常内容 -->
    <template v-else>
      <v-app-bar flat>
        <v-container class="mx-auto d-flex align-center justify-center">
          <v-avatar
            class="me-4"
            color="primary"
            size="36"
          >
            <v-img src="https://www.jimimedia.cn/wp-content/themes/jimimedia/assets/images/icon.png" alt="logo" />
          </v-avatar>

          <v-toolbar-title>
            叽咪 PicStore
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn
            v-if="isLoggedIn"
            @click="logout"
            prepend-icon="mdi-logout"
            variant="text"
            class="ms-4"
          >
            退出登录
          </v-btn>
        </v-container>
      </v-app-bar>

      <v-main class="bg-grey-lighten-3">
        <v-container>
          <v-row>
            <v-col cols="2" v-if="isLoggedIn">
              <v-sheet rounded="lg">
                <v-list rounded="lg">
                  <v-list-item
                    prepend-icon="mdi-image"
                    title="图片管理"
                    value="images"
                    @click="$router.push('/images')"
                    link
                    :active="$route.path === '/images'"
                  ></v-list-item>
                  
                  <v-list-item
                    v-if="userInfo.is_admin"
                    prepend-icon="mdi-account-group"
                    title="用户管理"
                    value="users"
                    @click="$router.push('/users')"
                    link
                    :active="$route.path === '/users'"
                  ></v-list-item>
                  
                  <v-list-item
                    v-if="userInfo.is_admin"
                    prepend-icon="mdi-domain"
                    title="部门管理"
                    value="departments"
                    @click="$router.push('/departments')"
                    link
                    :active="$route.path === '/departments'"
                  ></v-list-item>

                  <v-divider class="my-2"></v-divider>

                  <v-list-item
                    color="grey-lighten-4"
                    title="刷新"
                    prepend-icon="mdi-refresh"
                    @click="refreshPage"
                    link
                  ></v-list-item>
                </v-list>
              </v-sheet>
            </v-col>

            <v-col :cols="isLoggedIn ? 10 : 12">
              <router-view></router-view>
            </v-col>

            
          </v-row>
        </v-container>
         <!-- footer -->
         <div class="text-center" style="margin-top: 20px;font-size: 14px;color: #999;">© 2023-{{ new Date().getFullYear() }} 杭州叽咪文化传媒有限公司</div>
         <!-- footer -->
      </v-main>
    </template>
  </v-app>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'App',
  data() {
    return {
      links: [
        {
          name: '图片管理',
          action: () => this.$router.push('/images'),
          disabled: !this.isLoggedIn
        },
        {
          name: '用户管理',
          action: () => this.$router.push('/users'),
          disabled: !this.isLoggedIn || !this.userInfo.is_admin
        },
        {
          name: '部门管理',
          action: () => this.$router.push('/departments'),
          disabled: !this.isLoggedIn || !this.userInfo.is_admin
        }
      ]
    }
  },
  computed: {
    ...mapState(['isLoggedIn', 'userInfo'])
  },
  methods: {
    logout() {
      if (confirm('您确定要退出登录吗？')) {
        this.$store.dispatch('logout');
      }
    },
    
    refreshPage() {
      window.location.reload()
    },
    
    // 检测是否为移动设备
    isMobileDevice() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
      return mobileRegex.test(userAgent);
    },
    
    // 检查屏幕宽度是否为移动设备
    isMobileScreen() {
      return window.innerWidth <= 768;
    },
    
    handleResize() {
      // 窗口大小变化时重新检测，但不需要特殊处理
      // 因为模板中的条件会自动重新计算
    }
  },
  async mounted() {
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
    
    // 检查登录状态
    const token = localStorage.getItem('token')
    if (token) {
      this.$store.commit('SET_TOKEN', token)
      await this.$store.dispatch('checkAuth')
    }
  },
  beforeUnmount() {
    // 移除事件监听器
    window.removeEventListener('resize', this.handleResize);
  },
  watch: {
    isLoggedIn(newVal) {
      // 更新链接状态
      this.links = [

      ]
    },
    'userInfo.is_admin'(newVal) {
      // 更新链接状态
      this.links = [

      ]
    },
    userInfo: {
      handler(newVal) {
        // 当用户信息变化时，更新链接状态
        this.links = [

        ]
      },
      deep: true
    }
  }
}
</script>

<style>
#app {
  font-family: 'Microsoft YaHei', Arial, sans-serif;
}

.mobile-block-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.v-list-item--active {
  background-color: rgb(var(--v-theme-primary));
  color: white;
}

.v-list-item--active .v-list-item__prepend .v-icon {
  color: white;
}
</style> 